import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
import { Translated, translate } from "./translated";
import { Markdown, interpolate } from "../markdown";
/**
 * Wrap your dynamic form in the <BlockComponentContext.Provider /> in order to customize the rendered block components.
 */
export const BlockComponentContext = createContext({
    Translated,
    translate,
    interpolate,
    Markdown,
});
export const useBlockComponentContext = () => useContext(BlockComponentContext);
export const BlockComponentContextProvider = ({ value, children, }) => {
    /**
     * Here we use the useState as useMemo, because we don't expect value to be changed.
     */
    const [components] = useState(() => ({
        Translated,
        translate,
        interpolate,
        Markdown,
        ...value,
    }));
    return (_jsx(BlockComponentContext.Provider, { value: components, children: children }));
};
